import contentTypes from '../utils/contentTypes.js';

export default function useContentTypes() {
  return {
    CONTENT_TYPES: contentTypes,
  }
}